import { Injectable } from "@angular/core";
import { HttpClient } from "../shared/wrappers/HttpClient";
import { UrlBuilder } from "../models/utils/url-builder.model";

@Injectable()
export class ProjectCostService {
    endPoint: String = "/project-cost";

    constructor(private httpClient: HttpClient) { }

    async getProjectCostAll(approvalsSearch) {
        const builder = new UrlBuilder([
            { key: "skip", value: approvalsSearch.skip },
            { key: "limit", value: approvalsSearch.limit }
        ]);

        var keyValueParams = [];

        for (let projectId of approvalsSearch.projects)
            keyValueParams.push({ key: "projects", value: projectId });

        for (let projectTypeId of approvalsSearch.projectType)
            keyValueParams.push({ key: "projectType", value: projectTypeId });

        for (let consultantId of approvalsSearch.consultants)
            keyValueParams.push({ key: "consultants", value: consultantId });

        for (let companyId of approvalsSearch.companies)
            keyValueParams.push({ key: "customers", value: companyId });

        for (let companyGroupId of approvalsSearch.companyGroups)
            keyValueParams.push({ key: "groups", value: companyGroupId });

        for (let month of approvalsSearch.months)
            keyValueParams.push({ key: "months", value: month });

        for (let year of approvalsSearch.years)
            keyValueParams.push({ key: "years", value: year });

        for (let divisions of approvalsSearch.divisions)
            keyValueParams.push({ key: "divisions", value: divisions });

        for (let centers of approvalsSearch.excellenceCenters)
            keyValueParams.push({ key: "excellenceCenters", value: centers });

        if(approvalsSearch.subDivision)
            for (let subDivision of approvalsSearch.subDivision)
                keyValueParams.push({ key: "subDivisions", value: subDivision });

        builder.addQueryStringParamsInsideFilter(keyValueParams);

        return await this.httpClient.get(builder.buildUrl(`${this.endPoint}`));
    }

    async getById(id: string) {
        return await this.httpClient.get(`${this.endPoint}/${id}`);
    }

    async getConsultantsByProject(projectId: string){
        return await this.httpClient.get(`${this.endPoint}/consultants?project=${projectId}`);
    }

    async putProjectionCost(projection: any) {
        return await this.httpClient.update(`${this.endPoint}`, projection._id, projection);
    }

    async createProjectionCust(projection: any) {
        return await this.httpClient.post(`${this.endPoint}`, projection);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/project-cost.service.ts